var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 11.9291V11.7191C12.0006 11.0391 12.4207 10.6791 12.8407 10.3891C13.2507 10.1091 13.6606 9.74914 13.6606 9.08914C13.6606 8.16914 12.9206 7.4291 12.0006 7.4291C11.0806 7.4291 10.3407 8.16914 10.3407 9.08914M11.9961 14.3191H12.0051M2.97656 20.4866V5.51172C2.97656 4.40715 3.87199 3.51172 4.97656 3.51172H19.0248C20.1293 3.51172 21.0247 4.40715 21.0247 5.51172V15.519C21.0247 16.6235 20.1293 17.519 19.0247 17.519H6.96875L2.97656 20.4866Z",
    stroke: "#282828",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.ee26e148556d7da0137e87c82842649f.svg";
export { ForwardRef as ReactComponent };